import { ElementRef, useEffect, useRef, useState } from 'react';

import 'mutationobserver-shim';
import Lottie from 'lottie-react';
import Box from '@mui/material/Box/Box';
import { UIElement } from '@adyen/adyen-web';

import newLoader from '../../../../../../assets/newLoader.json';

interface AdyenComponentContainerProps {
  element: UIElement;
  hideLoader?: boolean;
  className?: string;
}

export const AdyenComponentContainer = ({
  element,
  hideLoader = false,
  className,
}: AdyenComponentContainerProps) => {
  const containerRef = useRef<ElementRef<'div'>>();
  const [loaded, setLoaded] = useState(true);

  useEffect(() => {
    if (!element) return;

    if (element.isAvailable) {
      element
        .isAvailable()
        .then(() => {
          element.mount(containerRef.current!);
          setLoaded(true);
        })
        .catch(() => {
          setLoaded(true);
        });
    } else {
      element.mount(containerRef.current!);
      setLoaded(true);
    }

    return () => {
      element.unmount();
    };
  }, [element]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      if (containerRef.current?.children.length === 0) {
        setLoaded(false);
      }
    });

    observer.observe(containerRef.current!, { childList: true });

    return () => observer?.disconnect();
  }, []);

  if (loaded || hideLoader) {
    return <Box ref={containerRef} sx={{ height: '100%' }} className={className} />;
  }

  return (
    <Box className="loader-wrapper">
      <Lottie animationData={newLoader} style={{ height: '100%' }} size={100} />
    </Box>
  );
};
